import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import type { EIntegrationProvider, IIntegration } from 'src/services/api/integrations/types';

const PATH = 'api/landlord/calendar-integrations';

type Response = {
    google: IIntegration<EIntegrationProvider.GOOGLE>,
    outlook: IIntegration<EIntegrationProvider.OUTLOOK>,
}

export const useCalendarIntegrations = () => {
    return useQuery(
        [queryKeys.calendarIntegrations],
        () => apiClient(PATH).json<Response>(),
    );
};
